<cap-checkbox
  [formControl]="formControl"
  [formlyAttributes]="field"
  [tabIndex]="props.tabindex || null"
  [style]="props.style || null"
  [styleClass]="props.styleClass || null"
  (onChange)="props.onChange ? props.onChange($event) : null"
  [binary]="props.binary || true"
  [trueValue]="props.trueValue || true"
  [falseValue]="props.falseValue || false" />
